module.exports = __webpack_public_path__ + "static/media/inverse_logo.eeb62a87.png";